<template>
  <div
    class="dropdown-selector-item"
    :class="{ selected: selected }"
    :data-testid="dataTestid"
    @click="handleClick"
  >
    <div class="item-icon" :data-testid="`${dataTestid}-icon`">{{ icon }}</div>
    <div class="item-label" :data-testid="`${dataTestid}-label`">{{ label }}</div>
    <Icon v-if="selected" name="general.check" size="base" class="check-icon" :data-testid="`${dataTestid}-check`" />
  </div>
</template>

<script setup lang="ts">
import { Icon } from '../../icon';

export interface DropdownSelectorItemProps {
  icon: string;
  label: string;
  value: string;
  selected?: boolean;
  dataTestid?: string;
}

const props = withDefaults(defineProps<DropdownSelectorItemProps>(), {
  selected: false,
  dataTestid: 'dropdown-selector-item',
});

const emit = defineEmits<{
  select: [value: string];
}>();

const handleClick = () => {
  emit('select', props.value);
};
</script>

<style scoped>
.dropdown-selector-item {
  @apply rounded-10 h-11 flex items-center justify-start p-2.5 gap-2 w-full cursor-pointer transition-colors duration-200;
}

.dropdown-selector-item:hover {
  @apply bg-slate-100 dark:bg-zinc-700;
}

.dropdown-selector-item.selected {
  @apply bg-blue-50 dark:bg-blue-900/20;
}

.dropdown-selector-item.selected:hover {
  @apply bg-blue-100 dark:bg-blue-900/30;
}

.item-icon {
  @apply relative font-semibold text-xl leading-10;
}

.item-label {
  @apply relative text-sm leading-6 font-semibold text-slate-600 dark:text-zinc-300 flex-1;
}

.check-icon {
  @apply w-6 h-6 text-blue-600 dark:text-blue-500;
}
</style>